import script from "./InstallGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./InstallGuideModal.vue?vue&type=style&index=0&id=626c8b6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626c8b6f"]])

export default __exports__